import * as React from 'react';

const SvgAdditionsMode = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={25} fill="none" {...props}>
    <g clipPath="url(#additions-mode_svg__a)">
      <path
        d="M20 2.5H4c-1.1 0-1.99.9-1.99 2L2 22.5l4-4h14c1.1 0 2-.9 2-2v-12c0-1.1-.9-2-2-2m0 14H5.17l-.59.59-.58.58V4.5h16zm-14-4h2v2H6zm0-3h2v2H6zm0-3h2v2H6zm4 6h5v2h-5zm0-3h8v2h-8zm0-3h8v2h-8z"/>
    </g>
    <defs>
      <clipPath id="additions-mode_svg__a">
        <path d="M0 .5h24v24H0z"/>
      </clipPath>
    </defs>
  </svg>
);
export default SvgAdditionsMode;
